export default __webpack_public_path__ + "static/media/copy.23cb0068.svg";